import { useState } from 'react';
import { X, Zap } from 'lucide-react';

const DEV_USERS = ['rahul_ace', 'priya_queen', 'anita_blind', 'vikram_king'];

interface DevLoginModalProps {
  open: boolean;
  loading?: boolean;
  error?: string;
  onClose: () => void;
  onLogin: (username: string) => Promise<void>;
}

export default function DevLoginModal({ open, loading, error, onClose, onLogin }: DevLoginModalProps) {
  const [devUser, setDevUser] = useState('rahul_ace');

  if (!open) return null;

  return (
    <div className="provider-login-overlay fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal>
      <button type="button" className="absolute inset-0 bg-black/75" aria-label="Close" onClick={onClose} />
      <div className="provider-login-panel relative z-10 w-full max-w-md rounded-2xl p-6 sm:p-8">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg p-1 text-white/50 hover:text-white"
          aria-label="Close login"
        >
          <X size={20} />
        </button>

        <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-tp-gold/80">Sign in to play</p>
        <h2 className="mt-2 font-display text-2xl font-bold text-white">Take your seat</h2>
        <p className="mt-1 text-sm text-white/45">Dev login · production uses session token</p>

        {error && (
          <p className="mt-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300">{error}</p>
        )}

        <form
          className="mt-6 space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            await onLogin(devUser);
          }}
        >
          <div>
            <label htmlFor="dev-user" className="mb-2 block text-[10px] font-bold uppercase tracking-wider text-white/40">
              Player ID
            </label>
            <input
              id="dev-user"
              className="provider-login-input w-full rounded-xl px-4 py-3.5 text-white outline-none"
              value={devUser}
              onChange={(e) => setDevUser(e.target.value)}
              placeholder="Username"
              autoComplete="username"
            />
          </div>

          <div className="flex flex-wrap gap-2">
            {DEV_USERS.map((name) => (
              <button
                key={name}
                type="button"
                onClick={() => setDevUser(name)}
                className={`provider-quick-user ${devUser === name ? 'provider-quick-user-active' : ''}`}
              >
                {name.replace('_', ' ')}
              </button>
            ))}
          </div>

          <button type="submit" className="provider-play-btn w-full" disabled={loading}>
            <Zap size={16} />
            {loading ? 'Signing in…' : 'Enter lobby'}
          </button>
        </form>
      </div>
    </div>
  );
}
